import { render, staticRenderFns } from "./RemoteAttestation.vue?vue&type=template&id=597d2831&"
import script from "./RemoteAttestation.vue?vue&type=script&lang=ts&"
export * from "./RemoteAttestation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports